import { SVGProps } from 'react';

const Tally5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 4v16M9 4v16m5-16v16m5-16v16m3-14L2 18"
    />
  </svg>
);
export default Tally5;
